'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _reactEventListener = require('react-event-listener');

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _iconChevronDown = require('../icons/icon-chevron-down');

var _iconChevronDown2 = _interopRequireDefault(_iconChevronDown);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _combineStyles = require('../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

var _popOver = require('../pop-over');

var _popOver2 = _interopRequireDefault(_popOver);

var _getPopOverPosition = require('../internal/get-pop-over-position');

var _getPopOverPosition2 = _interopRequireDefault(_getPopOverPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var displayName = 'Select';

var propTypes = {
  /** The Select's content (MenuItem), each child must have a value prop */
  children: _propTypes2.default.node.isRequired,
  /** The Select's value */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Callback fired when Select's value changes
   *
   * function(event: object, value: string || number) => void
   */
  onChange: _propTypes2.default.func.isRequired,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the header element */
  headerStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** The Select's label */
  label: _propTypes2.default.node.isRequired,
  /** Override the styles of the label element */
  labelStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the content container */
  contentStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** The Select's placeholder */
  placeholder: _propTypes2.default.string,
  /** Display an error message */
  error: _propTypes2.default.node,
  /** Override the styles of the error element */
  errorStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** The header's icon color */
  iconColor: _propTypes2.default.string,
  color: _propTypes2.default.string.isRequired
};

var defaultProps = {
  value: '',
  style: {},
  headerStyle: {},
  labelStyle: {},
  contentStyle: {},
  placeholder: '',
  error: null,
  errorStyle: {},
  iconColor: _colors2.default.white
};

var Select = function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false,
      positioned: false,
      popOverWidth: '200px'
    }, _this.positionPopOver = function () {
      var button = _this.button.getBoundingClientRect();
      var popOver = _this.popOver.getBoundingClientRect();
      var container = _this.container.getBoundingClientRect();

      _this.setState({
        positioned: true,
        position: (0, _getPopOverPosition2.default)(button, popOver, 'select'),
        popOverWidth: container.width + 'px'
      });
    }, _this.toggleSelect = function () {
      var open = _this.state.open;


      _this.setState({
        open: !open
      });

      if (open) {
        _this.setState({
          positioned: false
        });
      }
    }, _this.closeSelect = function () {
      var open = _this.state.open;


      if (!open) {
        return false;
      }

      return _this.setState({
        open: false,
        positioned: false
      });
    }, _this.handleClickOutside = function () {
      return _this.closeSelect();
    }, _this.handleKeyUp = function (event) {
      if (event.which === 27) {
        _this.closeSelect();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Select, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _state = this.state,
          open = _state.open,
          positioned = _state.positioned;


      if (open && !positioned) {
        this.positionPopOver();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state2 = this.state,
          open = _state2.open,
          position = _state2.position,
          popOverWidth = _state2.popOverWidth;

      var _props = this.props,
          children = _props.children,
          value = _props.value,
          onChange = _props.onChange,
          label = _props.label,
          style = _props.style,
          headerStyle = _props.headerStyle,
          labelStyle = _props.labelStyle,
          contentStyle = _props.contentStyle,
          placeholder = _props.placeholder,
          error = _props.error,
          errorStyle = _props.errorStyle,
          color = _props.color,
          eventTypes = _props.eventTypes,
          outsideClickIgnoreClass = _props.outsideClickIgnoreClass,
          preventDefault = _props.preventDefault,
          stopPropagation = _props.stopPropagation,
          disableOnClickOutside = _props.disableOnClickOutside,
          enableOnClickOutside = _props.enableOnClickOutside,
          iconColor = _props.iconColor,
          custom = _objectWithoutProperties(_props, ['children', 'value', 'onChange', 'label', 'style', 'headerStyle', 'labelStyle', 'contentStyle', 'placeholder', 'error', 'errorStyle', 'color', 'eventTypes', 'outsideClickIgnoreClass', 'preventDefault', 'stopPropagation', 'disableOnClickOutside', 'enableOnClickOutside', 'iconColor']);

      var childrenWithProps = _react2.default.Children.map(children, function (child) {
        return _react2.default.cloneElement(child, {
          closeMenu: _this2.closeSelect,
          active: child.props.value === value,
          onClick: function onClick(event) {
            return onChange(event, child.props.value);
          }
        });
      });

      var activeChild = (0, _find2.default)(childrenWithProps, ['props.value', value]);

      var headerText = (0, _get2.default)(activeChild, 'props.text') || value || placeholder;

      var popOverStyle = (0, _combineStyles2.default)({ minWidth: popOverWidth, right: 'initial' }, contentStyle);

      return _react2.default.createElement(
        'section',
        _extends({
          ref: function ref(container) {
            _this2.container = container;
          },
          style: style
        }, custom),
        _react2.default.createElement(
          'span',
          { style: (0, _combineStyles2.default)(_styles2.default.label, labelStyle) },
          label
        ),
        _react2.default.createElement(
          'header',
          {
            ref: function ref(button) {
              _this2.button = button;
            },
            style: _getStyles2.default.header(error, color, headerStyle),
            onClick: this.toggleSelect
          },
          headerText,
          _react2.default.createElement(_iconChevronDown2.default, { color: iconColor, style: _getStyles2.default.icon(open) })
        ),
        _react2.default.createElement(
          _popOver2.default,
          {
            style: popOverStyle,
            open: open,
            popOverRef: function popOverRef(popOver) {
              _this2.popOver = popOver;
            },
            position: position
          },
          childrenWithProps
        ),
        error ? _react2.default.createElement(
          'span',
          { style: _getStyles2.default.error(errorStyle) },
          error
        ) : null,
        open ? _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }) : null
      );
    }
  }]);

  return Select;
}(_react.Component);

Select.displayName = displayName;
Select.propTypes = propTypes;
Select.defaultProps = defaultProps;

exports.default = Select;
module.exports = exports.default;